import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ChangeOrderButton,
	CreateEstimateButton,
	ExitButton,
	PlumbingBanner,
	PrintButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	RetailOrderReportType,
	ViewChangeRequestButton,
	WorkVerificationFormFiles
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';
import SubmitVerificationFormButton from '../../../features/cfi/retail-order/components/SubmitVerificationFormButton';

export default function UploadVerificationFormPage() {

	return (
		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards showPaymentInformationCard={true} />

			<RetailOrderProgress />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SubmitVerificationFormButton />
						</ToolbarItem>
						<ToolbarItem>
							<PrintButton reportType={RetailOrderReportType.Invoice} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.UploadFiles} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.UploadFiles} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={false}
						showActualInstallDates={false}
						showInvoiceDate={false}
						editCabinetDates={false} />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<WorkVerificationFormFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
